const Bold = text => <strong>{text}</strong>

export default Bold
